<template>
  <div class="card text-center m-2">
    <div class="card-body bg-white">
      <div class="row">
        <div class="col-lg-4">
          <div class="sk sk-circle mx-auto mb-2"></div>
          <div class="sk sk-line w-75 mx-auto mb-2"></div>
          <div class="sk sk-line w-100 mb-3"></div>
          <div class="sk sk-line w-50 mx-auto"></div>
        </div>
        <div class="col-lg-8 text-left">
          <div class="card mb-3">
            <div class="card-body">
              <div class="sk sk-line w-50 mb-3"></div>
              <div class="sk sk-block"></div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="sk sk-line w-50 mb-3"></div>
              <div class="sk sk-block"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "staff-card-skeleton"
};
</script>

<style scoped>
.sk {
  background: linear-gradient(90deg, #eee 25%, #ddd 37%, #eee 63%);
  background-size: 400% 100%;
  border-radius: 8px;
  animation: sk-shimmer 1.4s ease infinite;
}
.sk-circle {
  height: 50px;
  width: 50px;
  border-radius: 50%;
}
.sk-line {
  height: 12px;
}
.sk-block {
  height: 70px;
  width: 100%;
}
@keyframes sk-shimmer {
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
}
</style>
